/**
 * @flow
 * @relayHash dd2fbc65983c89ce3664e5bb92727c3f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlockEditInput = {
  id: string,
  title: string,
  active: boolean,
  slug: string,
  linkedArticles?: ?$ReadOnlyArray<?BlockEditItemInput>,
  clientMutationId?: ?string,
};
export type BlockEditItemInput = {
  title?: ?string,
  articleId?: ?string,
};
export type BlockEditMutationVariables = {|
  input: BlockEditInput
|};
export type BlockEditMutationResponse = {|
  +BlockEdit: ?{|
    +error: ?string,
    +blockEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type BlockEditMutation = {|
  variables: BlockEditMutationVariables,
  response: BlockEditMutationResponse,
|};
*/


/*
mutation BlockEditMutation(
  $input: BlockEditInput!
) {
  BlockEdit(input: $input) {
    error
    blockEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "BlockEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "BlockEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "BlockEditInput!"
      }
    ],
    "concreteType": "BlockEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blockEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "BlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Block",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BlockEditMutation",
  "id": null,
  "text": "mutation BlockEditMutation(\n  $input: BlockEditInput!\n) {\n  BlockEdit(input: $input) {\n    error\n    blockEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlockEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BlockEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8713e4d6dd98f0db3f970754648af24a';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/BlockEditMutation.graphql.js